import { InjectionToken } from '@angular/core'
import { Environment } from './environments'

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT')
export const STORAGE_PREFIX = new InjectionToken<string>('STORAGE_PREFIX')
export const TRANSLATION_PREFIX = new InjectionToken<string>(
  'TRANSLATION_PREFIX'
)
